import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../contexts/auth'
import './auth.scss'

function ForgotPassword() {
	const { forgotPassword } = useAuth()

	const [email, setEmail]   = useState('')
	const [message, setMessage] = useState('')
	const [loading, setLoading] = useState(false)

	async function handleSubmit(e) {
		e.preventDefault()
		setLoading(true)
		const msg = await forgotPassword(email)
		setMessage(msg)
		setLoading(false)
	}

	return (
		<div className='authPage'>
			<div className='authCard'>
				<h2>Reset password</h2>

				{message
					? <div className='authSuccess'>{message}</div>
					: (
						<form onSubmit={handleSubmit}>
							<div className='authField'>
								<label>Email address</label>
								<input
									type='email'
									value={email}
									onChange={e => setEmail(e.target.value)}
									required
									autoFocus
								/>
							</div>
							<button className='authBtn' disabled={loading}>
								{loading ? 'Sending…' : 'Send reset link'}
							</button>
						</form>
					)
				}

				<div className='authLinks'>
					<Link to='/login'>Back to login</Link>
				</div>
			</div>
		</div>
	)
}

export default ForgotPassword
